interface SidePanelProcessDescription {
	processType: 'Side Panel';
	windowId: number;
}

interface ServiceWorkerProcessDescription {
	processType: 'Service Worker';
}

interface ReportPageProcessDescription {
	processType: 'Report Page';
}

interface ContentScriptProcessDescription {
	processType: 'Content Isolated' | 'Content Main';
}

interface OffscreenScriptProcessDescription {
	processType: 'Offscreen Page';
}

interface SearchWebWorkerProcessDescription {
	processType: 'Search Web Worker';
}

interface ExtensionUIProcessDescription {
	processType: 'Extension UI';
}

interface PopupProcessDescription {
	processType: 'Popup';
}

export type ProcessInfoType = SidePanelProcessDescription |
	PopupProcessDescription |
	ServiceWorkerProcessDescription |
	ReportPageProcessDescription |
	ContentScriptProcessDescription |
	OffscreenScriptProcessDescription |
	SearchWebWorkerProcessDescription |
	ExtensionUIProcessDescription
	;

export class ProcessInfo {
	// _info?: ProcessInfo;
	// constructor() {}

	// public get info(): ProcessInfo | undefined {
	// 	return this._info;
	// }
	public static setProcess(info: ProcessInfoType) {
		const header = info.processType === "Content Isolated" || info.processType === "Content Main" ?
				`[${info.processType} at ${window.location.origin}${window.location.pathname}]:\n\t` :
				`[${info.processType}]: `;
	
		ProcessInfo.log = Function.prototype.bind.call(console.log, console, header);
		ProcessInfo.errorLog = Function.prototype.bind.call(console.error, console, header);
	}
	
	static log = Function.prototype.bind.call(console.log, console) as typeof console.log;
	static errorLog = Function.prototype.bind.call(console.error, console) as typeof console.error;

	// inServiceWorker(): this is ProcessInfoClass & { info: ServiceWorkerProcessDescription } {
	// 	return this.info?.processType === 'Service Worker';
	// }
	// inSidePanel(): this is ProcessInfoClass & { info: SidePanelProcessDescription } {
	// 	return this.info?.processType === 'Side Panel';
	// }
	// inReportPage(): this is ProcessInfoClass & { info: ReportPageProcessDescription } {
	// 	return this.info?.processType === 'Report Page';
	// }
	// inOffscreenScript(): this is ProcessInfoClass & { info: OffscreenScriptProcessDescription } {
	// 	return this.info?.processType === 'Offscreen Page';
	// }
	// get description(): string | undefined {
	// 	return this.inServiceWorker() ? 'Service Worker' :
	// 		this.inSidePanel() ?
	// 	`Side Panel for window ${this.info.windowId}` :
	// 			this.inOffscreenScript() ?
	// 	`Offscreen Script` :
	// 	undefined; // `${this._info?.processType}`;
	// }

	private static lastMsReported = performance.now();
	static resetTime = () => {
		ProcessInfo.lastMsReported = performance.now();
	}
	static updateTime = () => {
		const now = performance.now();
		const result = now - ProcessInfo.lastMsReported;
		ProcessInfo.lastMsReported = now;
		return result;
	}

}
